import * as React from 'react';
import './spinner.styles.scss';
// TODO - Add more types of local loaders, starting with spinner.
var Spinner = function (props) {
    var size = props.size, color = props.color;
    return (React.createElement("div", { className: "local-activity-indicator" },
        React.createElement("div", { className: "spin-loader-" + (size || 'default'), style: { borderTopColor: color } })));
};
export default Spinner;
//# sourceMappingURL=spinner.js.map